import { render, staticRenderFns } from "./srvTableBtn.vue?vue&type=template&id=d61d3fda&scoped=true&"
import script from "./srvTableBtn.vue?vue&type=script&lang=js&"
export * from "./srvTableBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d61d3fda",
  null
  
)

export default component.exports